import PropTypes from 'prop-types';
import React from 'react';
import {
  button,
  buttonGroup,
  primary,
} from 'src/styles/modules/button.module.scss';
import StatusOutage from 'src/svgs/status/outage.svg';
import {status} from 'src/shared/pagePaths';
import {header} from '../header.module.scss';
import {
  icon,
  text,
} from './style.module.scss';

export const OutageInterstitialView = ({
  hasOutageMessagesSegment,
  onScheduleCall,
  onStatusCenter,
  outageMessage,
}) => {
  return (
    <>
      <header className={header}>
        <StatusOutage className={icon} />
        {
          hasOutageMessagesSegment
            ? (
              <>
                <h1>It looks like you&#39;re affected by a local outage</h1>
                <p>Sorry for the inconvenience, we&#39;re working to resolve the issue. You can use the Status Center to view your connection status and check for updates.</p>
              </>
            )
            : (
              <>
                <h1 className={text}>We noticed you&apos;re experiencing a service outage</h1>
                <p>{outageMessage}</p>
              </>
            )
        }
      </header>
      <div className={buttonGroup}>
        <a className={`${button} ${primary}`} href={status()} onClick={onStatusCenter}>Visit Status Center</a>
        <button className={button} onClick={onScheduleCall}>Get a Call</button>
      </div>
    </>
  );
};

OutageInterstitialView.propTypes = {
  hasOutageMessagesSegment: PropTypes.bool,
  onScheduleCall: PropTypes.func.isRequired,
  onStatusCenter: PropTypes.func.isRequired,
  outageMessage: PropTypes.string.isRequired,
};
